import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExtractedBlogInstructions,
  BackendQueryBlogUrlInstructionsArgs,
} from 'src/types/backend';

const QUERY = gql`
  query BlogUrlInstructions($id: ID!) {
    blogUrlInstructions(id: $id) {
      instructions
      status
      extractionErrors
    }
  }
`;

type Variables = BackendQueryBlogUrlInstructionsArgs;
type Result = Pick<
  BackendExtractedBlogInstructions,
  'instructions' | 'status' | 'extractionErrors'
>;

export const queryBlogUrlInstructions = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
